<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      shape="square"
      finish-button-text="Create Site"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >

      <!-- Site Details -->
      <tab-content
        title="Location"
        :before-change="validationSiteInfo"
      >
        <validation-observer
          ref="siteInfo"
          tag="form"
        >
          <add-site-details
            :new-site="newSite"
          />
        </validation-observer>
      </tab-content>

      <!-- Site Contact
      <tab-content
        title="Contact"
        :before-change="validationSiteInfo"
      >
        <validation-observer
          ref="siteInfo"
          tag="form"
        >
          <add-site-contact
            :new-site="newSite"
          />
        </validation-observer>
      </tab-content>

      -->

      <!-- object  -->
      <tab-content
        title="Place Objects at Site"
        :before-change="validationFormUnits"
      >
        <validation-observer
          ref="object"
          tag="form"
        >
          <add-site-objects
            :v-if="objects.length > 0 "
            :new-site="newSite"
            :objects="objects"
          />
        </validation-observer>
      </tab-content>

      <!-- Summarry -->
      <tab-content
        title="Summary"
      >
        <add-site-summary
          :new-site="newSite"
        />
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { required } from '@validations'
import { API } from 'aws-amplify'
import { codeIcon } from './code'
import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries'
import AddSiteDetails from './AddSiteDetails.vue'
// import AddSiteContact from './AddSiteContact.vue'
import AddSiteObjects from './AddSiteObjects.vue'
import AddSiteSummary from './AddSiteSummary.vue'

export default {
  components: {
    ValidationObserver,
    FormWizard,
    TabContent,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AddSiteDetails,
    // AddSiteContact,
    AddSiteObjects,
    AddSiteSummary,
  },
  data() {
    return {
      // Form Input
      // Site
      newSite: {
        details: {
          name: '',
          address: '',
          zip_code: '',
          city: '',
          subRegion: '',
          region: '',
          country: '',
          AWSLongLat: [],
          AWSLocationLabel: '',
        },
        contact: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
        },
        objects: [],
      },
      objects: [],
    }
  },
  created() {
    this.listObjects()
  },
  methods: {
    async listObjects() {
      const { id } = JSON.parse(localStorage.getItem('workspace'))
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id,
        },
      }).then(response => {
        this.objects = response.data.getWorkspace.objects.items
      })
    },
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    async formSubmitted() {
      this.triggerToast('Creating Site', 'info', 'EditIcon')
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      const roles = ['admin', 'editor', 'viewer']
      const workspaceGroups = []
      roles.forEach(role => {
        workspaceGroups.push(`${workspaceId}.${role}`)
      })

      const createSite = {
        workspaceSitesId: workspaceId,
        workspaceGroups,
      }

      // Clean up
      Object.entries(this.newSite.details).forEach(([key, value]) => {
        switch (typeof value) {
          case 'string':
            if (value !== '') {
              createSite[key] = value
            }
            break
          case 'object':
            if (value.length !== 0) {
              createSite[key] = value
            }
            break
          default:
        }
      })
      // Create Site
      let siteId = ''
      await API.graphql({
        query: mutations.createSite,
        variables: {
          input: createSite,
        },
      }).then(response => {
        siteId = response.data.createSite.id
      })

      // Update Object with SiteID
      if (this.newSite.objects.length > 0) {
        this.newSite.objects.forEach(async object => {
          await API.graphql({
            query: mutations.updateObject,
            variables: {
              input: {
                id: object.id,
                siteObjectsId: siteId,
              },
            },
          }).then(response => {

          })
        })
      }
      this.$router.push('/sites')
    },
    validationSiteInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.siteInfo.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
          //  console.log('error')
            reject()
          }
        })
      })
    },
    validationFormDevice() {
      return new Promise((resolve, reject) => {
        this.$refs.object.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormUnits() {
      return new Promise((resolve, reject) => {
        this.$refs.object.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-autosuggest.scss';
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  .repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
